import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core";
import { CircularProgress, Checkbox } from "@material-ui/core";
import Scroll from "../../../../../components/InfiniteScroll/Scroll";
import InputMaskCurrency from "../../../../../components/Input/InputMaskCurrency";

const ProfissionalSaudeValorList = ({
  classes,
  listaModal,
  handleChangeCheckbox,
  handleChange,
  loadMore,
  lastScroll,
  loadingModal,
}) => {
  return (
    <div className={classes.content}>
      <Scroll
        loadMore={loadMore}
        hasMore={!lastScroll}
        pageStart={0}
        initialLoad={false}
        className={classes.scrollContainerModelos}
      >
        <div className={classes.titles}>
          <div className={classes.title}> Selecione o profissional </div>
          <div className={classes.motivoCancelamentoValorTitles}>
            <div className={classNames(classes.title, classes.titleValor)}>
              Valor
            </div>
          </div>
        </div>
        {listaModal.length > 0 &&
          listaModal.map((itemLista, index) => (
            <div className={classes.linha} key={index}>
              <div className={classes.checkboxDescricao}>
                <Checkbox
                  id={`cfg-psv-chk-${index}`}
                  color={"primary"}
                  onChange={() => handleChangeCheckbox(itemLista, index)}
                  checked={itemLista.profissionalSaude?.checked}
                />
                <div className={classes.profissionalSaude}>
                  {itemLista.profissionalSaude?.nome}
                </div>
              </div>
              <div className={classes.motivoCancelamentoValor}>
                <InputMaskCurrency
                  id={`cfg-psv-inp-val-${index}`}
                  name={"valor"}
                  value={itemLista.valor === 0 ? "" : itemLista.valor}
                  className={classNames(
                    classes.inputValor,
                    !itemLista.profissionalSaude?.checked && classes.inputValorDesabilitado
                  )}
                  onChange={(e) => handleChange(e, itemLista, index)}
                  disabled={!itemLista.profissionalSaude?.checked}
                />
              </div>
            </div>
          ))}
        {loadingModal && (
          <div className={classes.contentLoading}>
            <CircularProgress />
          </div>
        )}
      </Scroll>
    </div>
  );
};

const styles = {
  content: {
    height: "calc(100% - 105px)",
    overflow: "auto",
  },
  titles: {
    display: "flex",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    zIndex: 1,
    background: "#fff",
  },
  title: {
    fontSize: "10px",
    color: "#868686",
  },
  titleValor: {
    width: "100%",
    maxWidth: "104px",
  },
  profissionalSaude: {
    color: "#868686",
  },
  linha: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "4px",
  },
  inputValor: {
    background: "#F2F2F2",
    padding: "4px 4px 4px 8px",
    width: "90px",
    height: "30px",
    border: "1px solid rgba(220, 220, 220, 0.2)",
    borderRadius: "8px",
  },
  checkboxDescricao: {
    display: "flex",
    alignItems: "center",
    "&>span": {
      color: "#868686",
    },
  },
  contentLoading: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  scrollContainerModelos: {
    height: "100%",
  },
  inputValorDesabilitado: {
    color: "#E5E5E5",
  },
  motivoCancelamentoValorTitles: {
    gap: '8px',
    width: '120px',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center'
  },
  motivoCancelamentoValor: {
    display: "flex",
    gap: "8px",
  },
};

export default withStyles(styles)(ProfissionalSaudeValorList);
